export interface ResolvedPickedTwin<Row> {
  personaId: string
  detail: Row | null
}

/**
 * Exact tokens to rows, in the order asked for. A token the audience does not return is a null
 * detail, and a failed read leaves them all null: the selection itself survives either way.
 */
export async function resolvePickedTwins<Row extends { personaId: string }>(
  ids: Array<string>,
  load: (ids: Array<string>) => Promise<Array<Row>>,
): Promise<Array<ResolvedPickedTwin<Row>>> {
  let rows: Array<Row> = []
  try {
    rows = await load(ids)
  } catch {
    rows = []
  }
  const byToken = new Map(rows.map((row) => [row.personaId, row]))
  return ids.map((personaId) => ({ personaId, detail: byToken.get(personaId) ?? null }))
}
